<template>
  <v-app v-if="!isFetching">
    <v-toolbar class="hidden-sm-and-down" v-if="!showSelectedLocationDialog && !toolbarHidden">
      <v-toolbar-title>
        <router-link class="nav-item" to="/">
          {{
          translater.__("Rovaniemi Nature - Control Panel")
          }}
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-switch
        v-if="showOnlyHidden"
        :value="onlyHidden"
        v-model="onlyHidden"
        :label="translater.__('Only hidden')"
      ></v-switch>
      <Admin v-if="isAdmin" logout="logout" />
      <Moderator v-if="isModerator" logout="logout" />
      <Guest v-if="!isLoggedIn" />
    </v-toolbar>
    <div class="hidden-md-and-up">
      <v-expansion-panel>
        <v-expansion-panel-content>
          <div slot="header">
            <router-link class="nav-item" to="/">
              {{
              translater.__("Rovaniemi Nature - Control Panel")
              }}
            </router-link>
          </div>
          <AdminMedium v-if="isAdmin"></AdminMedium>
          <ModeratorMedium v-else-if="isModerator"></ModeratorMedium>

          <GuestMedium v-else></GuestMedium>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <SelectedLocation v-if="showSelectedLocationDialog" />
    <v-flex shrink v-if="hasMessage">
      <v-alert transition="scale-transition" :value="true" type="success">
        {{
        this.$store.getters['success/message']
        }}
      </v-alert>
    </v-flex>
    <v-flex shrink v-if="hasError">
      <v-alert transition="scale-transition" :value="true" type="error">
        {{
        this.$store.getters['error/error']
        }}
      </v-alert>
    </v-flex>
    <v-content fluid fill-height>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>



<script>
import { translater } from "./tools/translate";
import { AUTHORIZATION } from "./constants";
import Admin from "./common/toolbars/Admin";
import AdminMedium from "./common/toolbars/AdminMedium";
import ModeratorMedium from "./common/toolbars/ModeratorMedium";
import GuestMedium from "./common/toolbars/GuestMedium";

import Guest from "./common/toolbars/Guest";
import Moderator from "./common/toolbars/Moderator";
import SelectedLocation from "./routes/components/SelectedLocation";
import NavigationDrawer from "./routes/components/NavigationDrawer";

export default {
  name: "App",
  components: {
    Admin,
    Guest,
    SelectedLocation,
    NavigationDrawer,
    Moderator,
    AdminMedium,
    ModeratorMedium,
    GuestMedium
  },

  data() {
    return {
      isFetching: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.translater = translater;
    });
  },

  created() {
    this.isFetching = true;

    // fetch translater object to be used globally from store
    /*if(!this.$store.getters["translate/translater"])
            {
              this.$store.dispatch('translate/translater', translater);
            }*/

    // if the page is refreshed (f5 is pressed)
    // we need to renew the current "session"
    // so that the system is aware of the loggedin user
    if (!this.isLoggedIn) {
      if (window.localStorage.getItem(AUTHORIZATION)) {
        if (!this.$store.getters["usersAuthorization/privilegesChecked"]) {
          this.$store.dispatch("usersAuthorization/privileges");
        }

        this.$store
          .dispatch("auth/user")
          .then(res => {
            this.$store.commit("auth/user", res.data);
          })
          // if error while fetching the loggedin user, redirect to login
          // this could happen e.g if the token is tampered with
          .catch(err => {
            this.$router.push("/login");
          });
      } else {
        this.$router.push("/login");
      }
    }
  },

  computed: {
    showOnlyHidden() {
      return this.$store.getters["settings/showOnlyHidden"];
    },

    onlyHidden: {
      get() {
        let onlyHidden = window.localStorage.getItem("onlyHidden");
        //console.log("######### onlyHidden", onlyHidden)
        if (onlyHidden == 0 || onlyHidden == null) {
          onlyHidden = false;
        } else {
          onlyHidden = true;
        }

        return onlyHidden;
      },

      set() {
        let newValue = 1;
        let current = window.localStorage.getItem("onlyHidden");
        if (current == 1) {
          newValue = 0;
        }

        window.localStorage.setItem("onlyHidden", newValue);
        window.setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },

    toolbarHidden: {
      get() {
        return this.$store.getters["settings/toolbarHidden"];
      }
    },

    hasError: {
      get() {
        return this.$store.getters["error/hasError"];
      }
    },

    showSelectedLocationDialog: {
      get() {
        return this.$store.getters["locations/showSelectedLocationDialog"];
      },

      set(value) {
        this.$store.dispatch("locations/setShowSelectedLocationDialog", value);
      }
    },

    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      },

      set(value) {
        this.$store.dispatch("translate/translater", value);
        this.isFetching = false;
      }
    },

    isAdmin: {
      get() {
        return this.$store.getters["auth/isAdmin"];
      }
    },

    isModerator: {
      get() {
        return this.$store.getters["auth/isModerator"];
      }
    },

    hasMessage: {
      get() {
        return this.$store.getters["success/hasMessage"];
      }
    },

    isLoggedIn: {
      get() {
        return this.$store.getters["auth/isLoggedIn"];
      }
    }
  }
};
</script>